import { config } from '@brand';

export type PartnerRole = 'agent' | 'affiliate';

export const AGENT_PARAM = 'agent';
export const AFFILIATE_PARAM = 'affiliate';

export const isAgent = (partner: ContentfulPartner | null | undefined): boolean =>
  !!partner?.agentNumber;

export const partnerRole = (partner: ContentfulPartner): PartnerRole =>
  isAgent(partner) ? 'agent' : 'affiliate';

export const partnerKey = (partner: ContentfulPartner): string =>
  (partner.agentNumber || partner.partnerCode || '').trim();

export const isBrandRecord = (partner: ContentfulPartner): boolean =>
  partner.agentNumber === config.defaultAgentNumber;

export const producerNumberFor = (partner: ContentfulPartner | null | undefined): string =>
  partner?.agentNumber || config.defaultAgentNumber;

export const affiliateCodeFor = (
  partner: ContentfulPartner | null | undefined,
  fallback = ''
): string => {
  if (!partner) return fallback;

  if (!isAgent(partner)) return partnerKey(partner) || fallback;

  return fallback === partnerKey(partner) ? '' : fallback;
};

export const partnerQueryParams = (
  partner: ContentfulPartner | null | undefined
): Record<string, string> => {
  if (!partner || isBrandRecord(partner)) return {};

  const key = partnerKey(partner);

  if (!key) return {};

  return isAgent(partner) ? { [AGENT_PARAM]: key } : { [AFFILIATE_PARAM]: key };
};

export const partnerLink = (partner: ContentfulPartner, baseUrl: string): string => {
  const params = partnerQueryParams(partner);
  const [param, value] = Object.entries(params)[0] || [];

  const root = baseUrl.replace(/\/+$/, '');

  return param ? `${root}/?${param}=${encodeURIComponent(value)}` : `${root}/`;
};
